/* eslint-disable react/no-array-index-key */
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Star, { TYPES } from './components/Star';
import Container from './components/Container';

const STARS = 5;

const Stars = ({ score }) => {
  const stars = useMemo(() => new Array(STARS).fill(), []);
  const total = useMemo(() => parseInt(score, 10), [score]);
  return (
    <Container>
      {stars.map((_, index) => (
        <Star key={index} type={index < total ? TYPES.FULL : TYPES.EMPTY} />
      ))}
    </Container>
  );
};

Stars.propTypes = {
  score: PropTypes.number.isRequired,
};

export default memo(Stars);
